// src/@crema/utility/AppContextProvider/index.js (or wherever yours lives)
import React from 'react';
import PropTypes from 'prop-types';
import ThemeContextProvider from './ThemeContextProvider';
import LocaleContextProvider from './LocaleContextProvider'; // <-- ensure the filename matches
import LayoutContextProvider from './LayoutContextProvider';
import SidebarContextProvider from './SidebarContextProvider';

const AppContextProvider = ({children}) => (
  <ThemeContextProvider>
    <LocaleContextProvider>
      <LayoutContextProvider>
        <SidebarContextProvider>{children}</SidebarContextProvider>
      </LayoutContextProvider>
    </LocaleContextProvider>
  </ThemeContextProvider>
);

AppContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppContextProvider;
